import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000';
function Score() {
  const navigate = useNavigate();
  const [historique, setHistorique] = useState([]);
  const [chargement, setChargement] = useState(true);

  // ⏱️ États pour gérer le téléchargement du PDF et le chrono
  const [loadingPdfId, setLoadingPdfId] = useState(null);
  const [pdfTimer, setPdfTimer] = useState(0);
  const timerRef = useRef(null);

  // 👉 Récupération de l'utilisateur connecté
  const storedUser = JSON.parse(localStorage.getItem('user') || '{}');

  // 1. On va chercher l'historique au chargement de la page
  useEffect(() => {
    // Sécurité : on renvoie à la connexion s'il n'est pas loggé
    if (!storedUser || !storedUser.id) {
      navigate('/login');
      return;
    }

    // 👉 CORRECTION : On ajoute bien le user_id dans l'URL pour Python !
    fetch(`${API_URL}/history?user_id=${storedUser.id}`)
      .then(res => res.json())
      .then(data => {
        if (!data.error) {
          setHistorique(data);
        }
        setChargement(false);
      })
      .catch(err => {
        console.error("Erreur historique:", err);
        setChargement(false);
      });
  }, [navigate, storedUser.id]);

  // 🚀 2. FONCTION PDF (Copie sécurisée depuis le Dashboard)
  const downloadPastReport = async (audit) => {
    if (!storedUser || !storedUser.id) {
      alert("Veuillez vous reconnecter.");
      return;
    }

    setLoadingPdfId(audit.id);
    setPdfTimer(0);
    
    timerRef.current = setInterval(() => {
      setPdfTimer((prev) => prev + 1);
    }, 1000);

    try {
      const response = await fetch(`${API_URL}/generate-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          score: audit.score, 
          reponses: audit.responses, 
          entreprise: storedUser.company,
          user_id: storedUser.id // Paywall activé !
        }),
      });

      // Gestion du blocage (Paywall)
      if (response.status === 403) {
        const errorData = await response.json();
        alert(errorData.message); 
        navigate('/pricing'); 
        return;
      }

      if (!response.ok) throw new Error("Erreur de génération");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const dateAudit = new Date(audit.date).toLocaleDateString().replace(/\//g, '-');
      a.download = `Rapport_Expert_${dateAudit}.pdf`;
      a.click();

    } catch (error) {
      console.error('Erreur PDF:', error);
      alert("Erreur lors de la génération du PDF.");
    } finally {
      clearInterval(timerRef.current);
      setLoadingPdfId(null);
      setPdfTimer(0);
    }
  };

  // Fonction pour donner une belle étiquette de couleur selon le score
  const getBadgeStyle = (score) => {
    if (score >= 80) return { bg: '#e8f8f5', color: '#27ae60', texte: '✅ Conforme' };
    if (score >= 50) return { bg: '#fef9e7', color: '#f39c12', texte: '⚠️ Vigilance' };
    return { bg: '#fdedec', color: '#e74c3c', texte: '❌ Risque' };
  };

  // Fonction pour formater la date proprement
  const formaterDate = (dateString) => {
    if (!dateString) return "Date inconnue";
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR') + ' à ' + date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div style={{ padding: '30px', maxWidth: '1000px', margin: '0 auto', fontFamily: '"Inter", Arial, sans-serif' }}>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #ecf0f1', paddingBottom: '15px', marginBottom: '30px' }}>
        <h1 style={{ color: '#2c3e50', margin: 0 }}>Historique des Audits</h1>
        <Link to="/audit">
          <button style={{ padding: '10px 20px', background: '#3498db', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
            + Nouvel Audit
          </button>
        </Link>
      </div>

      {chargement ? (
        <p style={{ textAlign: 'center', color: '#7f8c8d' }}>Chargement de l'historique...</p>
      ) : historique.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '50px', background: '#fdfdfd', borderRadius: '10px', border: '1px dashed #bdc3c7' }}>
          <p style={{ fontSize: '18px', color: '#7f8c8d' }}>Aucun audit n'a encore été réalisé.</p>
          <p>Lancez votre premier audit pour voir apparaître vos résultats ici.</p>
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
            <thead>
              <tr style={{ background: '#2c3e50', color: 'white' }}>
                <th style={{ padding: '15px' }}>N° Audit</th>
                <th style={{ padding: '15px' }}>Date de réalisation</th>
                <th style={{ padding: '15px' }}>Score</th>
                <th style={{ padding: '15px' }}>Statut</th>
                <th style={{ padding: '15px', textAlign: 'right' }}>Rapport PDF</th> {/* Nouvelle colonne ! */}
              </tr>
            </thead>
            <tbody>
              {historique.map((ligne) => {
                const badge = getBadgeStyle(ligne.score);
                return (
                  <tr key={ligne.id} style={{ borderBottom: '1px solid #ecf0f1', transition: 'background 0.3s', cursor: 'default' }} onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'} onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                    <td style={{ padding: '15px', fontWeight: 'bold', color: '#3498db' }}>#{ligne.id}</td>
                    <td style={{ padding: '15px', color: '#7f8c8d' }}>{formaterDate(ligne.date)}</td>
                    <td style={{ padding: '15px', fontWeight: 'bold', fontSize: '16px' }}>{ligne.score}%</td>
                    <td style={{ padding: '15px' }}>
                      <span style={{ background: badge.bg, color: badge.color, padding: '5px 12px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold' }}>
                        {badge.texte}
                      </span>
                    </td>
                    <td style={{ padding: '15px', textAlign: 'right' }}>
                      {/* 👉 Le bouton de téléchargement intégré au tableau */}
                      <button 
                        onClick={() => downloadPastReport(ligne)} 
                        disabled={loadingPdfId === ligne.id} 
                        style={{ 
                          padding: '8px 15px', 
                          cursor: loadingPdfId === ligne.id ? 'not-allowed' : 'pointer', 
                          borderRadius: '6px', 
                          border: '1px solid #ddd', 
                          background: loadingPdfId === ligne.id ? '#f1f5f9' : '#fff', 
                          color: loadingPdfId === ligne.id ? '#94a3b8' : '#2c3e50',
                          fontWeight: 'bold',
                          fontSize: '13px'
                        }}>
                        {loadingPdfId === ligne.id ? `⏳ En cours... (${pdfTimer}s)` : '📄 Télécharger'}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Score;